import SecondMainClient from "components/Client&Partner/2ndMainClient";
import SecondMainEvent from "components/Events/2ndMainEvent";
import AllEvents from "components/Events/AllEvents";
import BookSection from "components/Events/BookSection";
import HeroEvent from "components/Events/HeroEvent";
import MainEvent from "components/Events/MainEvent";
import MissionEvent from "components/Events/MissionEvent";
import Fbpost from "components/Fbchatplusgin/Fbpost";
import LatestWorkshop from "components/Homepage/LatestWorkshop";
import UpcomingEvent from "components/Homepage/UpcomingEvent";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Events = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");

      setTimeout(() => {
        const element = document.getElementById(id);

        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  }, [location]);
  return (
    <div>
      {/* <HeroEvent /> */}
      <MissionEvent />
      <div id="upcoming">
        {" "}
        <AllEvents />
        {/* <LatestWorkshop /> */}
      </div>{" "}
      {/* <Fbpost /> */}
      {/* <MainEvent /> */}
      {/* <div id="private">
        <SecondMainEvent />
      </div> */}
      <div id="book">
        <BookSection />
      </div>
    </div>
  );
};

export default Events;
